import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";

// A per-date-column marker (shape: dot | diamond | flag). Absolutely positioned
// at `x` within a row. Clicking fires `onClick(anchorRect)` so the caller can
// open the event popover next to it.
export default function DateMarker({ col, x, value, taskName, canEdit, isCritical, onClick }) {
  const shape = col.shape || "dot";
  return (
    <TooltipProvider delayDuration={150}>
      <Tooltip>
        <TooltipTrigger asChild>
          <div
            data-event-anchor="marker"
            onClick={(e) => {
              if (!canEdit || !onClick) return;
              e.stopPropagation();
              const rect = e.currentTarget.getBoundingClientRect();
              onClick(rect);
            }}
            className={`absolute z-20 cursor-pointer ${isCritical ? "critical-bar" : ""}`}
            style={{ left: x, top: "50%", transform: "translate(-50%, -50%)" }}
            data-testid={`gantt-marker-${col.id}`}
          >
            {shape === "diamond" && (
              <div
                className={`w-3.5 h-3.5 rotate-45 border-2 border-white shadow-md ${isCritical ? "ring-2 ring-red-500" : ""}`}
                style={{ background: col.color }}
              />
            )}
            {shape === "flag" && (
              <div className="relative">
                <div className="w-[2px] h-5" style={{ background: col.color }} />
                <div
                  className="absolute top-0 left-[2px] h-2.5 w-3"
                  style={{ background: col.color, clipPath: "polygon(0 0, 100% 50%, 0 100%)" }}
                />
              </div>
            )}
            {shape === "dot" && (
              <div
                className="w-3 h-3 rounded-full border-2 border-white shadow-md"
                style={{ background: col.color }}
              />
            )}
          </div>
        </TooltipTrigger>
        <TooltipContent className="rounded-md text-xs">
          <div className="font-semibold">{taskName}</div>
          <div className="text-slate-300">{col.label}</div>
          <div className="font-mono-ibm">{value}</div>
          {isCritical && <div className="text-red-300 font-semibold mt-1">ON CRITICAL PATH</div>}
          {canEdit && <div className="text-[10px] text-slate-400 mt-1 italic">Click to add comment/icon</div>}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
